{ doAction, fail, success } = require './index'

FAILED_CREATE_MESSAGE = 'Failed to create a new classroom'
SUCCEEDED_CREATE_MESSAGE = 'Classroom created'
CREATED_CLASSROOM = 'CREATED_CLASSROOM'
CREATING_CLASSROOM = 'CREATING_CLASSROOM'

FAILED_DELETE_MESSAGE = 'Deletion failed'
SUCCEEDED_DELETE_MESSAGE = 'Classroom deleted'
DELETED_CLASSROOM = 'DELETED_CLASSROOM'
DELETING_CLASSROOM = 'DELETING_CLASSROOM'

FAILED_FETCH_MESSAGE = 'Failed to retrieve the list of classrooms from the server'
FETCHED_CLASSROOMS = 'FETCHED_CLASSROOMS'
FETCHING_CLASSROOMS = 'FETCHING_CLASSROOMS'
FETCHED_CLASSROOM = 'FETCHED_CLASSROOM'
FETCHING_CLASSROOM = 'FETCHING_CLASSROOM'

FAILED_FETCHING_INSTRUCTORS_MESSAGE = 'Failed to retrieve the list of instructors from the server'
FETCHED_INSTRUCTORS = 'FETCHED_INSTRUCTORS'
FETCHING_INSTRUCTORS = 'FETCHING_INSTRUCTORS'

FETCHED_TEACHERS = 'FETCHED_TEACHERS'
FETCHING_TEACHERS = 'FETCHING_TEACHERS'

FAILED_GROUPING_STUDENTS_MESSAGE = 'Failed to group students'
SUCCEEDED_GROUPING_STUDENTS_MESSAGE = 'Students were successfully grouped'
GROUPED_STUDENTS = 'GROUPED_STUDENTS'
GROUPING_STUDENTS = 'GROUPING_STUDENTS'

FAILED_UPDATE_MESSAGE = 'Update failed'
SUCCEEDED_UPDATE_MESSAGE = 'Classroom updated'
UPDATED_CLASSROOM = 'UPDATED_CLASSROOM'
UPDATING_CLASSROOM = 'UPDATING_CLASSROOM'

SELECT_CLASSROOM = 'SELECT_CLASSROOM'

url = '/api/classrooms'

fetchClassroom = (classroomId) ->
	fetchUrl = url + "/#{classroomId}"
	method = 'get'
	payload = null
	doingActionType = FETCHING_CLASSROOM
	didActionType = FETCHED_CLASSROOM
	failureMessage = FAILED_FETCH_MESSAGE
	successMessage = null
	getSuccessPayload = (responseJson) ->
		classroom: responseJson.data.classroom
	doAction(fetchUrl, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)

module.exports = {
	FAILED_CREATE_MESSAGE
	CREATED_CLASSROOM
	CREATING_CLASSROOM

	FAILED_DELETE_MESSAGE
	DELETED_CLASSROOM
	DELETING_CLASSROOM

	FAILED_FETCH_MESSAGE
	FETCHED_CLASSROOMS
	FETCHING_CLASSROOMS
	FETCHED_CLASSROOM
	FETCHING_CLASSROOM

	FETCHED_INSTRUCTORS
	FETCHING_INSTRUCTORS

	FETCHED_TEACHERS
	FETCHING_TEACHERS

	GROUPED_STUDENTS
	GROUPING_STUDENTS

	FAILED_UPDATE_MESSAGE
	UPDATED_CLASSROOM
	UPDATING_CLASSROOM

	SELECT_CLASSROOM

	createClassroom: (classroom) ->
		method = 'post'
		payload = classroom
		doingActionType = CREATING_CLASSROOM
		didActionType = CREATED_CLASSROOM
		failureMessage = FAILED_CREATE_MESSAGE
		successMessage = SUCCEEDED_CREATE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	deleteClassroom: (classroomId) ->
		method = 'delete'
		payload = { id: classroomId }
		doingActionType = DELETING_CLASSROOM
		didActionType = DELETED_CLASSROOM
		failureMessage = FAILED_DELETE_MESSAGE
		successMessage = SUCCEEDED_DELETE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	fetchClassrooms: ->
		method = 'get'
		payload = null
		doingActionType = FETCHING_CLASSROOMS
		didActionType = FETCHED_CLASSROOMS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage)

	fetchClassroom

	fetchInstructors: (classroomId) ->
		groupUrl = url + "/#{classroomId}/instructors"
		method = 'get'
		payload = null
		doingActionType = FETCHING_INSTRUCTORS
		didActionType = FETCHED_INSTRUCTORS
		failureMessage = FAILED_FETCHING_INSTRUCTORS_MESSAGE
		doAction(groupUrl, method, payload, doingActionType, didActionType, failureMessage)

	fetchTeachers: (classroomId) ->
		groupUrl = url + "/#{classroomId}/teachers"
		method = 'get'
		payload = null
		doingActionType = FETCHING_TEACHERS
		didActionType = FETCHED_TEACHERS
		failureMessage = FAILED_FETCHING_INSTRUCTORS_MESSAGE
		doAction(groupUrl, method, payload, doingActionType, didActionType, failureMessage)

	groupStudents: (classroomId) ->
		groupUrl = url + "/group_students"
		method = 'post'
		payload = { id: classroomId }
		doingActionType = GROUPING_STUDENTS
		didActionType = GROUPED_STUDENTS
		failureMessage = FAILED_GROUPING_STUDENTS_MESSAGE
		successMessage = SUCCEEDED_GROUPING_STUDENTS_MESSAGE
		getSuccessPayload = (responseJson) ->
			classroom: responseJson.data.classroom
		doAction(groupUrl, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)

	selectClassroom: (classroom) ->
		return {
			type: SELECT_CLASSROOM,
			payload: {
				classroom: classroom
			}
		}

	updateClassroom: (classroom) ->
		method = 'PATCH'
		payload = classroom
		doingActionType = UPDATING_CLASSROOM
		didActionType = UPDATED_CLASSROOM
		failureMessage = FAILED_UPDATE_MESSAGE
		successMessage = SUCCEEDED_UPDATE_MESSAGE
		getSuccessPayload = (responseJson) ->
			list: responseJson.data.list
			classroom: responseJson.data.classroom
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/classrooms.coffee